<template>
	<div class="container modularTwo">
		<img
			v-for="(item,index) in arrData" :key="index"
			:src="item.img"
			@click="goPage(item)"
		>
	</div>
</template>

<script>
	import bus from '../../assets/bus';
	export default {
		props:{
			componentType:{
				type:String,
				default:""
			},
			componentId:{
				type:String,
				default:""
			}
		},
		data() {
			return {
				arrData:[],
			}
		},
		created(){
			this.getData()
		},
		methods:{
			getData(){
				let that = this
				var url = "/index.php/AppInterface/IndexModule"+that.componentType+"/index"
				that.$server.post( url, {
					id: that.componentId,
				})
				.then(res => {
					switch (res.result) {
						case 1:
							that.arrData = res.data.index_arr.item_arr||[]
							break;
						default:
							uni.showToast({
								icon: "none",
								title: res.data.msg
							});
							break;
					}
				})
			},
			
			goPage(item){
				if(item.relevance_type == 1) {
					bus.$emit('goProduct', {
						path:"/productDetail",
						query:{
							id: item.relevance_id
						}
					})
				}
				// 商品分类
				else if(item.relevance_type == 2) {
					// url:"/pages/navigation/index?id="+item.relevance_id+"&componentId="+item.componentId
					bus.$emit('goProduct', {
						path: '/classify',
						query: {
							type: 1,
							id: item.relevance_id,
							componentId: item.componentId,
						}
					})
				}
				// 品牌
				else if(item.relevance_type == 3) {
					console.log('goBanner goBrand')
					bus.$emit('goProduct', {
						path: '/classify',
						query: {
							type: 0,
							id: item.relevance_id,
							componentId: item.componentId,
						}
					})
				}
			}
		}
	}
</script>

<style lang="scss">
	.modularTwo{
		margin: 0 auto;
		width: $container-MaxWidth;
		max-width: $container-MaxWidth;
		min-width: $container-MaxWidth;
		
		img {
			display: block;
			width: 100%;
			cursor: pointer;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/modular/modular_two.vue